/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_A1Inputs */

const es_marketplace_seo_galicia_faq_a1 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las salidas más habituales son desde la Ría de Arousa: O Grove, Cambados, Vilanova de Arousa y alrededores. Consulta los anuncios de experiencias en la zona para ver horarios y duración.`)
};

const gl_marketplace_seo_galicia_faq_a1 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As saídas máis habituais son dende a Ría de Arousa: O Grove, Cambados, Vilanova de Arousa e arredores. Consulta os anuncios de experiencias na zona para ver horarios e duración.`)
};

const en_marketplace_seo_galicia_faq_a1 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most trips leave from Ría de Arousa: O Grove, Cambados, Vilanova de Arousa and nearby ports. Check experience listings in the area for schedules and duration.`)
};

/**
* | output |
* | --- |
* | "Most trips leave from Ría de Arousa: O Grove, Cambados, Vilanova de Arousa and nearby ports. Check experience listings in the area for schedules and duration." |
*
* @param {Marketplace_Seo_Galicia_Faq_A1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_a1 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_A1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_A1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_a1(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_a1(inputs)
	return es_marketplace_seo_galicia_faq_a1(inputs)
});